import { Injectable } from "@angular/core";
import { ProductMtaAgreementModel } from "../../models/components/product-mta-agreement.model";
import { ProductPopUpBaseService } from "./product-pop-up-base.service";

@Injectable({
    providedIn: "root"
})
export class ProductMtaPopUpService extends ProductPopUpBaseService<ProductMtaAgreementModel> { }
